import { IconButton, Tooltip, Card, CardHeader, Divider, Grid, Paper, Typography, Button, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { Icons } from '../../../assets/icons';
import { useFileDownload } from "../../../components/file-download";
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import { LoadingIndicator } from '../../../components/loading-indicator.component';

interface UnitHVACGradingComponent {
    unitData: any;
}

export const UnitHVACGradingComponent = ({ unitData }: UnitHVACGradingComponent) => {

    const { downloadFile, isLoading: isLoadingFileDownload } = useFileDownload();

    const styling = {
        root: { borderRadius: '10px' },
        textColor: { color: '$primary-color' },
        headingStyle: { color: '#0000b5', paddingBottom: '10px' },
        labelStyle: { color: '#0000b5', fontSize: '14px' },
        valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
    };

    const handleDownloadFile = async (data: any) => {
        const value = {
            unitID: Number(unitData?.unitID) || 0,
            fileName: data?.accaReportFileName,
            fileType: data?.accaReportFileType,
            fileSection: "accafile"
        };
        downloadFile({ additionalData: value });
    };

    return (
        <Card elevation={0}>
            {isLoadingFileDownload && <LoadingIndicator isLoading={isLoadingFileDownload} />}
            <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
                <Grid container>
                    <Grid item xl={2.5} lg={2.5} sm={4} xs={6}>
                        <FormGroup>
                            <FormControlLabel disabled control={<Checkbox checked={unitData?.includeHVACGrading == true ? true : false} />} label="HVAC Grading" />
                        </FormGroup>
                        {unitData?.includeHVACGrading && (
                            <FormGroup>
                                <FormControlLabel disabled control={<Checkbox checked={unitData?.weighInDataReceived == true ? true : false} />} label="Weigh in data received" />
                            </FormGroup>
                        )}
                    </Grid>
                    <Grid item xl={9.5} lg={9.5} sm={8} xs={6}>
                        {unitData?.includeHVACGrading && (
                            <Grid container>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 1 Designed AH Model</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys1DesignedAHModel ? '---' : `${unitData?.sys1DesignedAHModel}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 1 Blower Fan Airflow Design</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys1BlowerFanAirflowDesign ? '---' : `${unitData?.sys1BlowerFanAirflowDesign}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 1 Blower Fan Airflow Design Setting</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys1BlowerFanAirflowDesignSetting ? '---' : `${unitData?.sys1BlowerFanAirflowDesignSetting}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 2 Designed AH Model</label>
                                        <span style={styling.valueStyle}>{!unitData?.designedAHModel ? '---' : `${unitData?.designedAHModel}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 2 Blower Fan Airflow Design</label>
                                        <span style={styling.valueStyle}>{!unitData?.blowerFanAirflowDesign ? '---' : `${unitData?.blowerFanAirflowDesign}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 2 Blower Fan Airflow Design Setting</label>
                                        <span style={styling.valueStyle}>{!unitData?.blowerFanAirflowDesignSetting ? '---' : `${unitData?.blowerFanAirflowDesignSetting}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={12} lg={12} sm={12} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>ACCA 310 Design Report</label>
                                        <span style={styling.valueStyle}>
                                            {' '}
                                            {!unitData?.accaReportFileName ? '---' : unitData?.accaReportFileName}
                                            {!!unitData?.accaReportFileName && (
                                                <GuardedComponent requiredPermissions={[UserPermissionName.DOWNLOAD_FILE]}>
                                                    <span>
                                                        <IconButton aria-label="download" onClick={() => handleDownloadFile(unitData)}>
                                                            <img src={Icons.FileDownload} alt="Download" />
                                                        </IconButton>
                                                    </span>
                                                </GuardedComponent>
                                            )}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 1 Airflow Result</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys1AirFlowResult ? '---' : `${unitData?.sys1AirFlowResult}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 1 Airflow Scoring</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys1AirFlowScoring ? '---' : `${unitData?.sys1AirFlowScoring}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 1 Airflow Grading</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys1AirFlowGrading ? '---' : `${unitData?.sys1AirFlowGrading}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 2 Airflow Result</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys2AirFlowResult ? '---' : `${unitData?.sys2AirFlowResult}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 2 Airflow Scoring</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys2AirFlowScoring ? '---' : `${unitData?.sys2AirFlowScoring}`}</span>
                                    </Typography>
                                </Grid>
                                <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>System 2 Airflow Grading</label>
                                        <span style={styling.valueStyle}>{!unitData?.sys2AirFlowGrading ? '---' : `${unitData?.sys2AirFlowGrading}`}</span>
                                    </Typography>
                                </Grid>
                                 <Grid item xl={4} lg={4} sm={4} xs={6}>
                                    <Typography className="d-flex flex-column mBm">
                                        <label style={styling.labelStyle}>Liquid Line Length</label>
                                        <span style={styling.valueStyle}>{!unitData?.liqLineLength ? '---' : `${unitData?.liqLineLength}`}</span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Paper>
        </Card>
    );
}